import React, { ReactNode } from 'react';
import { BannerType, MessageBanner } from '../messageBanner';
import { ErrorImage } from '../../../assets/images';

export interface ErrorBannerProps {
  title?: string;
  text?: string;
  content?: ReactNode;
}

const ErrorBanner: React.FC<ErrorBannerProps> = (props: ErrorBannerProps) => {
  return (
    <MessageBanner
      imageSource={ErrorImage}
      imageAlternateText="Error"
      title={props.title}
      text={props.text}
      content={props.content}
      bannerType={BannerType.Error}
    />
  );
};

export default ErrorBanner;
